import { Component } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget } from '../../../ui/widget';
import { DevoPipelinePageService } from './devo-pipeline.page.service';
import { DevoPipelineTab1Part } from './tabs/tab-1/devo-pipeline-tab-1.part';
import { DevoPipelineTab2Part } from './tabs/tab-2/devo-pipeline-tab-2.part';
import { DevoPipelineViewsPart } from './views/devo-pipeline-views.part';


@Component({
	selector: 'devo-pipeline-page',
	standalone: true,
	imports: [
		DevoPipelineTab1Part,
		DevoPipelineTab2Part,
		DevoPipelineViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		DroplistWidget,
		ToolbarWidget,],
	templateUrl: './devo-pipeline.page.html',
})
export class DevoPipelinePage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: DevoPipelinePageService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}